/* eslint-disable @typescript-eslint/no-explicit-any */

import { clone, concat, findIndex } from 'es-toolkit/compat';
import { getActiveInOrder, getArchived } from 'utils/entityUtils';
import { safeToNumber } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  activePackages: any[];
  archivedPackages: any[];
  allPackages: any[];
  isInitialized: boolean;
}

const initialState = {
  activePackages: [],
  archivedPackages: [],
  allPackages: [],
  isInitialized: false,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.PACKAGE_ADD_DONE: {
      const allPackages = concat(state.allPackages, [payload]);
      return {
        ...state,
        activePackages: getActiveInOrder(allPackages),
        allPackages,
        archivedPackages: getArchived(allPackages),
      };
    }
    case AppConstants.PACKAGE_UPDATE_DONE: {
      const pack = payload;
      if (!pack.id) {
        // eslint-disable-next-line no-console
        console.warn('Cannot update a package with no id property!');
        return state;
      }
      // Since we have a reference to the state's object directly,
      // we can mutate it here.
      const idx = findIndex(
        state.allPackages,
        (existingPackage) => safeToNumber(existingPackage.id) === safeToNumber(pack.id)
      );
      const allPackages = clone(state.allPackages);
      allPackages[idx] = pack;
      return {
        ...state,
        activePackages: getActiveInOrder(allPackages),
        allPackages,
        archivedPackages: getArchived(allPackages),
      };
    }
    case AppConstants.PACKAGE_FETCH_ALL_DONE: {
      const allPackages = payload;
      return {
        ...state,
        activePackages: getActiveInOrder(allPackages),
        allPackages,
        archivedPackages: getArchived(allPackages),
        isInitialized: true,
      };
    }
    case AppConstants.PACKAGE_FETCH_ALL_STARTING: {
      return {
        ...state,
        isInitialized: false,
      };
    }
    case AppConstants.PACKAGE_FETCH_ALL_FAILED: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    default:
      return state;
  }
}
